import { render, staticRenderFns } from "./TraxTrainingRegistrationTopBox.vue?vue&type=template&id=b94983b0"
import script from "./TraxTrainingRegistrationTopBox.vue?vue&type=script&lang=js"
export * from "./TraxTrainingRegistrationTopBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports